import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, TextArea, Label, Message } from 'semantic-ui-react'

class ClassRemarksApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: '',
      levelHeadNotes: '',
      registrarNotes: '',
      principalNotes: '',
      discardNotes: '',
      error: false,
      errorDiscard: false,
      modalOpen: false
    };
  }

  handleOpenDiscard = () => this.setState({ modalOpen: true })

  handleCloseDiscard = () => this.setState({ modalOpen: false, errorDiscard: false })

  handleClose = () => {
    this.setState({ error: false }, this.props.handleApprovalClose())
  }

  handleUpdate = () => {
    if (!this.props.sectionDetail) return;

    const id = this.props.sectionDetail.sectionDetailId;
    const status = this.props.sectionDetail.status;
    let data;

    if(status === 'To Do' || status === 'Discarded') {
      if (this.state.notes === '') {
        this.setState({ error: true });
      } else {
        data = {
          notes: this.state.notes,
          createdDate: new Date(),
          createdBy: this.props.username,
          file: this.props.fileName,
          discardNotes: '',
          discardDate: undefined,
          discardBy: '',
          status: 'Created'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }
    } else if (status === 'Created') {
      if (this.state.levelHeadNotes === '') {
        this.setState({ error: true });
      } else {
        data = {
          levelHeadNotes: this.state.levelHeadNotes,
          checkedDate: new Date(),
          checkedBy: this.props.username,
          status: 'Checked'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }

    } else if (status === 'Checked') {
      if (this.state.registrarNotes === '') {
        this.setState({ error: true });
      } else {
        data = {
          registrarNotes: this.state.registrarNotes,
          reviewedDate: new Date(),
          reviewedBy: this.props.username,
          status: 'Reviewed'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }
    } else if (status === 'Reviewed') {
      if (this.state.principalNotes === '') {
        this.setState({ error: true });
      } else {
        data = {
          principalNotes: this.state.principalNotes,
          approvedDate: new Date(),
          approvedBy: this.props.username,
          status: 'Approved'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }
    }
  }

  handleDiscard = () => {
    if (!this.props.sectionDetail) return;

    const id = this.props.sectionDetail.sectionDetailId;
    const status = this.props.sectionDetail.status;
    let data;

    if (status === 'Created') {
      if (this.state.discardNotes === '') {
        this.setState({ errorDiscard: true });
      } else {
        data = {
          notes: '',
          file: '',
          createdDate: undefined,
          createdBy: '',
          discardNotes: this.state.discardNotes,
          discardDate: new Date(),
          discardBy: this.props.username,
          status: 'Discarded'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }
    } else if (status === 'Checked') {
      if (this.state.discardNotes === '') {
        this.setState({ errorDiscard: true });
      } else {
        data = {
          notes: '',
          file: '',
          createdDate: undefined,
          createdBy: '',
          registrarNotes: '',
          reviewedDate: undefined,
          reviewedBy: '',
          discardNotes: this.state.discardNotes,
          discardDate: new Date(),
          discardBy: this.props.username,
          status: 'Discarded'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }
    } else if (status === 'Reviewed') {
      if (this.state.discardNotes === '') {
        this.setState({ errorDiscard: true });
      } else {
        data = {
          notes: '',
          file: '',
          createdDate: undefined,
          createdBy: '',
          registrarNotes: '',
          reviewedDate: undefined,
          reviewedBy: '',
          principalNotes: '',
          approvedDate: undefined,
          approvedBy: '',
          discardNotes: this.state.discardNotes,
          discardDate: new Date(),
          discardBy: this.props.username,
          status: 'Discarded'
        }
        this.props.handleUpdateSectionDetails(data,id);
      }
    }
  }

  handleInputChange = (e, { name, value }) => {
    this.setState({[name]: value})
  }

  render() {
    console.log('s',this.props.sectionDetail);

    // Handle case where sectionDetail is undefined
    if (!this.props.sectionDetail) {
      return null;
    }

    const status = this.props.sectionDetail.status;
    let content, actionButtons;
    if (status === 'To Do' || status === 'Discarded') {
      content = (
        <div>
          <Form>
            <strong>Notes:</strong>
            <Form.Field error={this.state.error}>
              <TextArea
                name = "notes"
                onChange = {this.handleInputChange}
                rows = {4}
               />
            </Form.Field>
          </Form>
        </div>
      )
      actionButtons = (
        <Button
          positive
          icon='checkmark'
          labelPosition='right'
          content='Submit'
          onClick={this.handleUpdate}
        />
      )
    } else if(status === 'Created') {
      content = (
        <div>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionDetail.notes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.userType === 'admin' || this.props.userType === 'levelHead' ?
              <span>
                <strong>Level Head Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "levelHeadNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </span> :
              null
            }
          </Form>
        </div>
      )
      actionButtons = (
        <div>
          {
            this.props.userType === 'admin' || this.props.userType === 'levelHead' ?
            <span><Button
              positive
              icon='checkmark'
              labelPosition='right'
              content='Submit'
              onClick={this.handleUpdate}
            />
            <Button
              negative
              icon='trash'
              labelPosition='right'
              content='Discard'
              onClick={this.handleOpenDiscard}
            /> </span>:
            null
          }
        </div>
      )
    } else if(status === 'Checked') {
      content = (
        <div>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionDetail.notes}
                rows = {4}
               />
            </Form.Field>
            <strong>Level Head Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Checked by {this.props.sectionDetail.checkedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "levelHeadNotes"
                disabled
                value={this.props.sectionDetail.levelHeadNotes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.userType === 'admin' || this.props.userType === 'registrar' ?
              <span>
                <strong>Registrar Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "registrarNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </span> : null
            }
          </Form>
        </div>
      )
      actionButtons = (
        <div>
          {
            this.props.userType === 'admin' || this.props.userType === 'registrar' ?
            <span><Button
              positive
              icon='checkmark'
              labelPosition='right'
              content='Submit'
              onClick={this.handleUpdate}
            />
            <Button
              negative
              icon='trash'
              labelPosition='right'
              content='Discard'
              onClick={this.handleOpenDiscard}
            /> </span> :
            null
          }
        </div>
      )
    } else if(status === 'Reviewed') {
      content = (
        <div>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionDetail.notes}
                rows = {4}
               />
            </Form.Field>
            <strong>Level Head Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Checked by {this.props.sectionDetail.checkedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "levelHeadNotes"
                disabled
                value={this.props.sectionDetail.levelHeadNotes}
                rows = {4}
               />
            </Form.Field>
            <strong>Registrar Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Reviewed by {this.props.sectionDetail.reviewedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "registrarNotes"
                disabled
                value={this.props.sectionDetail.registrarNotes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.userType === 'admin' || this.props.userType === 'principal' ?
              <span>
                <strong>Principal Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "principalNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </span> :
              null
            }
          </Form>
        </div>
      )
      actionButtons = (
        <div>
          {
            this.props.userType === 'admin' || this.props.userType === 'principal' ?
            <span><Button
              positive
              icon='checkmark'
              labelPosition='right'
              content='Submit'
              onClick={this.handleUpdate}
            />
            <Button
              negative
              icon='trash'
              labelPosition='right'
              content='Discard'
              onClick={this.handleOpenDiscard}
            /> </span> :
            null
          }
        </div>
      )
    } else if(status === 'Approved') {
      content = (
        <div>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionDetail.notes}
                rows = {4}
               />
            </Form.Field>
            <strong>Level Head Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Checked by {this.props.sectionDetail.checkedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "levelHeadNotes"
                disabled
                value={this.props.sectionDetail.levelHeadNotes}
                rows = {4}
               />
            </Form.Field>
            <strong>Registrar Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Reviewed by {this.props.sectionDetail.approvedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "registrarNotes"
                disabled
                value={this.props.sectionDetail.registrarNotes}
                rows = {4}
               />
            </Form.Field>
            <strong>Principal Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Approved by {this.props.sectionDetail.reviewedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "principalNotes"
                disabled
                value={this.props.sectionDetail.principalNotes}
                rows = {4}
               />
            </Form.Field>
          </Form>
        </div>
      )
      actionButtons = null;
    } else {
      content = (
        <h3> Invalid Status </h3>
      )
    }
    
    return (
      <Modal
        trigger={
          <Button color='blue' floated='right' onClick={this.props.handleApprovalOpen}>
            Go To Approval Process
          </Button>
        }
        open={this.props.open}
        onClose={this.handleClose}
        closeIcon
        >
        <Modal.Header>Class Remark Approval</Modal.Header>
        <Modal.Content>
          {
            this.state.error ?
            <Message
              error
              header="Errors"
              list={[
                'Required fields cannot be empty',
              ]}
            /> :
            null
          }
          <div>
            {content}
          </div>
        </Modal.Content>
        <Modal.Actions>
          {actionButtons}
        </Modal.Actions>
        <Modal
          open={this.state.modalOpen}
          onClose={this.handleCloseDiscard}
          closeIcon
          size='small'
        >
          <Modal.Content>
            {
              this.state.errorDiscard ?
              <Message
                error
                header="Errors"
                list={[
                  'Required fields cannot be empty',
                ]}
              /> :
              null
            }
            <Form>
              <strong>Discard Notes:</strong>
              <Form.Field error={this.state.errorDiscard}>
                <TextArea
                  name = "discardNotes"
                  onChange = {this.handleInputChange}
                  rows = {4}
                 />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color='orange' onClick={this.handleDiscard}>
              <Icon name='trash' /> Discard
            </Button>
          </Modal.Actions>
        </Modal>
      </Modal>
    )
  }
};

export default ClassRemarksApproval;
